import {
  SET_CREDIT_CHECK_PERSONAL_DATA,
  SET_CREDIT_CHECK_EMPLOYMENT_DATA,
  SET_CREDIT_CHECK_HOME_DATA,
  SET_CREDIT_CHECK_DEBIT_DATA,
  SET_CREDIT_CHECK_DELIVERY_DATA,
  SET_CREDIT_CHECK_CONTACT_DATA,
  SET_CREDIT_CHECK_AFFORD_DEAL,
  SET_CREDIT_SELECTED_AFFORD_DEAL,
  SET_CREDIT_VETTING_OUTCOME,
} from "../actionTypes/index";

const initialState = {
  personalDetails: null,
  employmentDetails: null,
  homeDetails: null,
  debitDetails: null,
  deliveryDetails: null,
  contactDetails: null,
  isShowAffordDeal: false,
  isSelectedAffordDeal: true,
  creditVettingDetails: null,
};

const creditCheckReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CREDIT_CHECK_PERSONAL_DATA:
      return {
        ...state,
        personalDetails: payload,
      };

    case SET_CREDIT_CHECK_EMPLOYMENT_DATA:
      return {
        ...state,
        employmentDetails: payload,
      };

    case SET_CREDIT_CHECK_HOME_DATA:
      return {
        ...state,
        homeDetails: payload,
      };

    case SET_CREDIT_CHECK_DEBIT_DATA:
      return {
        ...state,
        debitDetails: payload,
      };

    case SET_CREDIT_CHECK_DELIVERY_DATA:
      return {
        ...state,
        deliveryDetails: payload,
      };

    case SET_CREDIT_CHECK_CONTACT_DATA:
      return {
        ...state,
        contactDetails: payload,
      };
    case SET_CREDIT_CHECK_AFFORD_DEAL:
      return {
        ...state,
        isShowAffordDeal: payload,
      };
    case SET_CREDIT_SELECTED_AFFORD_DEAL:
      return {
        ...state,
        isSelectedAffordDeal: payload,
      };
    case SET_CREDIT_VETTING_OUTCOME:
      return {
        ...state,
        creditVettingDetails: payload,
      };

    default:
      return state;
  }
};

export default creditCheckReducer;
